export default "__VITE_ASSET__ff6e8bbb__"